// store/notificationStore.ts
import { NotificationType } from '@visualizer/types';
import { create } from 'zustand';

type Notification = {
    id: string;
    message: string;
    severity: NotificationType;
    closable?: boolean; // NEW: show "X" button
    persistent?: boolean; // NEW: don't auto-hide
};

type NotificationStore = {
    notifications: Notification[];
    showNotification: (message: string, severity?: Notification['severity'], closable?: boolean, persistent?: boolean) => void;
    dismissNotification: (id: string) => void;
    hideNotification: () => void;
};

let notificationCounter = 0;

const useNotificationStore = create<NotificationStore>((set) => ({
    notifications: [],
    showNotification: (message, severity = NotificationType.Info, closable = false, persistent = false) =>
        set((state) => {
            const isDuplicate = state.notifications.some((item) => item.message === message);
            if (isDuplicate) {
                return state;
            }

            return {
                notifications: [
                    ...state.notifications.slice(Math.max(0, state.notifications.length - 2)),
                    {
                        id: `notification-${notificationCounter++}`,
                        message,
                        severity,
                        closable,
                        persistent,
                    },
                ],
            };
        }),
    dismissNotification: (id) =>
        set((state) => ({
            notifications: state.notifications.filter((item) => item.id !== id),
        })),
    hideNotification: () =>
        set(() => ({
            notifications: [],
        })),
}));

export default useNotificationStore;
